import React from 'react';
import { graphql } from 'gatsby';
import {
  StyledApiIntegrationsBlockWrapper,
  StyledApiIntegrationsBlock,
  StyledCards,
  StyledCard
} from './styles';
import { uid } from 'react-uid';
import SectionHeader from '../SectionHeader';
import Section from '../Section';
import SendGridLink from '../../SendGridLink';
import UpLeftArrow from '../../../assets/svg/icons/up-left-arrow.svg';

const GlobalContentApiIntegrationsBlock = ({ block }) => {
  return (
    <StyledApiIntegrationsBlockWrapper>
      <Section theme="white">
        <SectionHeader tagline={block.headline} title={block.subheadline} marginBottomTablet={'68px'} marginBottomMobile={'68px'} />
        <StyledApiIntegrationsBlock>
          <div id="partners">
            <h2>Partners</h2>
            <div className="title-hr"></div>
            {block.partners.map((partner) => (
              <div>
                <img
                  src={partner.logo.sourceUrl}
                  alt={partner.logo.alt}
                />
                <p>{partner.mainText}</p>
                <SendGridLink
                  href={partner.ctaLink}
                  className="arrow-link partners__cta"
                >
                  {partner.ctaText}
                </SendGridLink>
              </div>
            ))}            
          </div>
          <div id="platforms">
            <h2>Platforms</h2>
            <div className="title-hr"></div>
            {block.platforms && (
              <StyledCards>            
                {block.platforms.map((platform) => (
                    <StyledCard key={uid(platform)} href={platform.ctaLink}>
                      <img
                        src={platform.logo.sourceUrl}
                        alt={platform.logo.alt}
                      />
                      <UpLeftArrow />
                    </StyledCard>
                ))}
              </StyledCards>
            )}
          </div>
        </StyledApiIntegrationsBlock>
      </Section>
     </StyledApiIntegrationsBlockWrapper>
  );
};

export default GlobalContentApiIntegrationsBlock;

export const query = graphql`
  fragment ApiIntegrationsBlockFragment on WPGraphQL_Page {
    acfGlobalContentBlocks {
      contentBlocks {
        ... on WPGraphQL_Page_Acfglobalcontentblocks_ContentBlocks_ApiIntegrationsBlock {
          fieldGroupName
          headline
          subheadline
          partners {
            name
            mainText
            ctaLink
            ctaText
            logo {              
              altText
              sourceUrl
            }
          }
          platforms {
            fieldGroupName
            name
            ctaLink
            logo {              
              altText
              sourceUrl
            }
          }
        }
      }
    }
  }
`;
